import { render, staticRenderFns } from "./cowWeightGainIndividualBetweenMonths.vue?vue&type=template&id=0be3422c&scoped=true&"
import script from "./cowWeightGainIndividualBetweenMonths.vue?vue&type=script&lang=js&"
export * from "./cowWeightGainIndividualBetweenMonths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be3422c",
  null
  
)

export default component.exports